import { React } from '@digsup/core-ui';
import PropTypes from 'prop-types';

export const LabBg = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="1068"
    height="516"
    className={className}>
    <defs>
      <linearGradient
        id="a"
        x1=".5"
        x2=".5"
        y2="1"
        gradientUnits="objectBoundingBox">
        <stop offset="0" stopColor="#f2f2f2" />
        <stop offset="1" stopColor="#d8d6ce" />
      </linearGradient>
      <linearGradient id="b" x1="0" x2="1" y1=".5" y2=".5" xlinkHref="#a" />
      <linearGradient
        id="c"
        x2="1"
        y1=".5"
        y2=".5"
        gradientUnits="objectBoundingBox">
        <stop offset="0" stopColor="#1f92be" />
        <stop offset=".2" stopColor="#36b6d8" />
        <stop offset=".9" stopColor="#1f7ba8" />
        <stop offset=".9" stopColor="#1f7daa" />
        <stop offset="1" stopColor="#1f84b1" />
        <stop offset="1" stopColor="#1f92be" />
      </linearGradient>
      <linearGradient
        id="d"
        x2="1"
        y1=".5"
        y2=".5"
        gradientUnits="objectBoundingBox">
        <stop offset="0" stopColor="#ca7ed0" />
        <stop offset=".3" stopColor="#f496d0" />
        <stop offset="1" stopColor="#9c7ed0" />
      </linearGradient>
    </defs>
    <path
      fill="none"
      stroke="#d3eff6"
      strokeMiterlimit="10"
      strokeWidth="7.9"
      d="M218 138.8c0-14.1-.3-27-.2-29.9 5.8-230.5-330.2-33.8-114.3 163.3 83.1 75.8 199.3 96.5 275.7 96.5 411.4 0 380.6-178 490.7-191.5"
    />
    <path
      fill="none"
      stroke="#d3eff6"
      strokeMiterlimit="10"
      strokeWidth="7.9"
      d="M438.5 140v-2.3C438.5 76 459.8 5.2 598.8 5.2c173.2 0 288.2 109 288.2 109"
    />
    <path
      fill="none"
      stroke="#26b0d5"
      strokeDasharray="24.6 49.2 9.8"
      strokeLinecap="round"
      strokeMiterlimit="10"
      strokeWidth="3.9"
      d="M438.5 140v-2.3c0-61.8 21.7-133 160.7-133C772.4 4.7 887 114.2 887 114.2"
      className="l-homepage-hero-lab-asset__stroke"
    />
    <path
      fill="none"
      stroke="#d3eff6"
      strokeMiterlimit="10"
      strokeWidth="7.9"
      d="M328 138.4v-36a464.4 464.4 0 013.2-54.8c4.3-36.1 24.4-75.7 41-1.4 22.1 99 21 238.6 196.4 223 141.8-12.8 187-155.6 303-125"
    />
    <path
      fill="none"
      stroke="#f3b65a"
      strokeDasharray="24.6 49.2 9.8"
      strokeLinecap="round"
      strokeMiterlimit="10"
      strokeWidth="3.9"
      d="M328 138.4v-36a464.4 464.4 0 013.2-54.8c4.3-36.1 24.4-75.7 41-1.4 22.1 99 21 238.6 196.4 223 141.8-12.8 187-155.6 303-125"
      className="l-homepage-hero-lab-asset__stroke"
    />
    <g transform="translate(1144.7 6232.21)">
      <circle
        cx="71.5"
        cy="71.5"
        r="71.5"
        fill="#d3eff6"
        transform="translate(-255.84 -6138.5)"
      />
      <path
        fill="#c8ebf3"
        d="M-171-6127.1a61.7 61.7 0 0146.8 73.5 61.7 61.7 0 01-73.5 46.8 61.7 61.7 0 01-46.7-73.6c7.3-33.1 44.4-53.2 73.5-46.7m2.1-9.7a71.5 71.5 0 00-85.3 54.3 71.5 71.5 0 0054.2 85.3 71.5 71.5 0 0085.4-54.2 71.5 71.5 0 00-54.3-85.4z"
      />
      <path
        fill="#d3eff6"
        d="M-268-6092.9c.2.1.2.6.2 1.4l-.2 1.2a46.3 46.3 0 01-1.8 7.7c-.3.7-.5 1.1-.7 1.1l16.8 3.8a5.2 5.2 0 001.6 0 5.6 5.6 0 003.8-2l.3-.3a6 6 0 001-2.2 6.1 6.1 0 000-2.4v-.5a5.6 5.6 0 00-2.6-3.4 5.1 5.1 0 00-1.5-.6l-16.9-3.8z"
      />
      <ellipse
        cx="5.9"
        cy=".7"
        fill="#d8d6ce"
        rx="5.9"
        ry=".7"
        transform="rotate(-77.45 -3927.76 -2871.69)"
      />
      <path fill="#d8d6ce" d="M-268-6092.9l-2.5 11.5-4.1-.1 2.9-13z" />
      <ellipse
        cx="6.6"
        cy=".7"
        fill="#eceade"
        rx="6.6"
        ry=".7"
        transform="rotate(-77.45 -3929.93 -2869.17)"
      />
      <path
        fill="#d3eff6"
        d="M-231.3-6141.5c0 .1-.2.5-.8 1l-1 .8a43.2 43.2 0 01-6.7 4.1l-1.3.4 9.2 14.5a5.2 5.2 0 001 1.2 5.6 5.6 0 004.2 1.2h.4a6 6 0 002.3-1 6.1 6.1 0 001.7-1.6l.3-.4a5.6 5.6 0 00.6-4.2 5.2 5.2 0 00-.6-1.5l-9.3-14.6z"
      />
      <ellipse
        cx="5.9"
        cy=".7"
        fill="#d8d6ce"
        rx="5.9"
        ry=".7"
        transform="rotate(-32.47 -10656 -2653.17)"
      />
      <path fill="#d8d6ce" d="M-231.3-6141.5l-9.9 6.3-2.8-3 11.2-7.1z" />
      <ellipse
        cx="6.6"
        cy=".7"
        fill="#eceade"
        rx="6.6"
        ry=".7"
        transform="rotate(-32.47 -10663.5 -2649.5)"
      />
      <path
        fill="#d3eff6"
        d="M-252.5-6121.4c.1.2 0 .6-.4 1.3a23.2 23.2 0 01-2.4 4 44.1 44.1 0 01-2.8 3.5c-.5.6-.9.9-1 .9l14.1 9.7a5.3 5.3 0 001.5.7 5.6 5.6 0 004.2-.4l.4-.3a6 6 0 001.8-1.6 6.1 6.1 0 001-2.2v-.5a5.6 5.6 0 00-1-4.2 5.1 5.1 0 00-1.2-1l-14.2-9.9z"
      />
      <ellipse
        cx="5.9"
        cy=".7"
        fill="#d8d6ce"
        rx="5.9"
        ry=".7"
        transform="rotate(-55.36 -5955.58 -2808.48)"
      />
      <path fill="#d8d6ce" d="M-252.5-6121.4l-6.7 9.7-3.7-1.7 7.5-10.9z" />
      <ellipse
        cx="6.6"
        cy=".7"
        fill="#eceade"
        rx="6.6"
        ry=".7"
        transform="rotate(-55.36 -5959.1 -2805.71)"
      />
      <path
        fill="#d3eff6"
        d="M-270-6049.7l17.1-2.2a5.1 5.1 0 001.6-.4 5.6 5.6 0 002.8-3.2l.2-.4a6.1 6.1 0 00.2-2.4 6 6 0 00-.8-2.3c0-.2-.2-.3-.3-.4a5.6 5.6 0 00-3.5-2.4 5.3 5.3 0 00-1.6 0l-17.2 2.1h.1l.5 1.2.3 1.3a43.8 43.8 0 01.9 7.8c0 .8-.1 1.2-.2 1.3z"
      />
      <ellipse
        cx=".7"
        cy="5.9"
        fill="#d8d6ce"
        rx=".7"
        ry="5.9"
        transform="rotate(-7.25 -47975 -884)"
      />
      <path fill="#d8d6ce" d="M-270-6049.7l-1.4-11.6-4.1-.3 1.7 13.2z" />
      <ellipse
        cx=".7"
        cy="6.6"
        fill="#eceade"
        rx=".7"
        ry="6.6"
        transform="rotate(-7.25 -47978 -852.56)"
      />
    </g>
    <g transform="translate(1144.7 6232.21)">
      <rect
        width="34.5"
        height="77.4"
        fill="#d3eff6"
        rx="17.2"
        transform="rotate(-48.98 -6683.63 -2836.22)"
      />
      <g
        fill="none"
        stroke="#c8ebf3"
        strokeMiterlimit="10"
        strokeWidth="5.7"
        transform="rotate(-48.98 -6683.63 -2836.22)">
        <rect width="34.5" height="77.4" rx="17.2" stroke="none" />
        <rect width="28.8" height="71.6" x="2.9" y="2.9" rx="14.3" />
      </g>
      <path
        fill="none"
        stroke="#b0e1ec"
        strokeMiterlimit="10"
        strokeWidth="4"
        d="M-146-6030.8l5.3 4.7a.5.5 0 010 .7l-1.4 1.8a2.1 2.1 0 002.5 3.3l7.3-3.5a2.1 2.1 0 012.5 3.3l-3.8 4.3a2.1 2.1 0 002.6 3.4l7.2-3.5a2.1 2.1 0 012.6 3.3l-3.8 4.3a2.1 2.1 0 002.5 3.3l7.3-3.5a2.1 2.1 0 012.6 3.3l-3.8 4.4a2.1 2.1 0 002.5 3.3l7.3-3.5a2.1 2.1 0 012.5 3.3l-3.7 4.3a2.1 2.1 0 002.5 3.3l7.3-3.4a2.1 2.1 0 012.5 3.3l-3.7 4.3a2.1 2.1 0 002.5 3.3l3.3-1.6a.5.5 0 01.6 0l5.2 4.6"
      />
    </g>
    <g transform="translate(1144.7 6232.21)">
      <path
        fill="url(#a)"
        d="M-383.4-5900.8c.4.2.8 1.3 1 3.2l.4 3.3a111 111 0 01-.4 20c-.2 1.9-.6 3-1 3.2H-256a13.3 13.3 0 004-.6 14.2 14.2 0 008.2-7.2l.5-1a15.4 15.4 0 001.2-6 15.5 15.5 0 00-1.2-6l-.5-1.1a14.1 14.1 0 00-8.2-7.2 13 13 0 00-4-.6h-127.5z"
        opacity=".6"
      />
      <path
        fill="#f7f7f2"
        d="M-404-5896.9l-.1 3a102.7 102.7 0 01-3.3 18.8c-.5 1.6-1 2.6-1.3 2.8l8 1.2c.2 0 .4-.2.6-.5a20 20 0 001.8-5.4v-.1a125.6 125.6 0 002.5-15v-.1a20 20 0 00-.1-5.8c0-.3-.2-.5-.4-.6l-8-1.4c.3.3.4 1.4.4 3.1z"
      />
      <ellipse
        cx="14"
        cy="1.6"
        fill="#f7f7f2"
        rx="14"
        ry="1.6"
        transform="rotate(-80.96 -3645.25 -2695.96)"
      />
      <ellipse
        cx="14.9"
        cy="1.7"
        fill="#d8d6ce"
        rx="14.9"
        ry="1.7"
        transform="rotate(-80.96 -3644.11 -2696.37)"
      />
      <path fill="#d8d6ce" d="M-402.5-5901l-4.7 29.5-10.4.3 5.3-33.3z" />
      <ellipse
        cx="16.9"
        cy="1.9"
        fill="#f7f7f2"
        rx="16.9"
        ry="1.9"
        transform="rotate(-80.96 -3649.23 -2690.05)"
      />
      <ellipse
        cx="1.7"
        cy="14.9"
        fill="url(#b)"
        opacity=".6"
        rx="1.7"
        ry="14.9"
        transform="translate(-384.88 -5900.81)"
      />
      <path
        fill="#d8d6ce"
        d="M-243.2-5892l-.5-1a14.1 14.1 0 00-8.2-7.1 13 13 0 00-4-.7h-127.5c.4.1.8 1.3 1 3.2l.4 3.3a111.6 111.6 0 01-.4 20c-.2 1.9-.6 3-1 3.2H-256a13.2 13.2 0 004-.7 14.2 14.2 0 008.2-7l.5-1.2a15.4 15.4 0 001.2-6 15.5 15.5 0 00-1.2-6zm-.9 11.7l-.4 1a13.3 13.3 0 01-7.7 6.6h-.2a12.4 12.4 0 01-3.5.6h-126a19.6 19.6 0 00.5-2.1l.3-3.3a108.6 108.6 0 00-.3-20.2 19.7 19.7 0 00-.4-2.1H-256a12.2 12.2 0 013.6.5l.2.1a13.2 13.2 0 017.6 6.6 10.4 10.4 0 01.4 1 14.5 14.5 0 011.1 5.6 14.4 14.4 0 01-1 5.7z"
        opacity=".5"
      />
      <path
        fill="#d8d6ce"
        d="M-382-5894.5l-.4-3.2c-.2-1.8-.5-3-.9-3.2h-.1c.4.1.8 1.3 1 3.2a52.4 52.4 0 01.4 3.2zm40.6 22.3a23.5 23.5 0 004.2.2h72.2c3 0 5.4 0 7.5-.2z"
        opacity=".5"
      />
      <path
        fill="url(#c)"
        d="M-244.2-5880.3c0 .3-.2.6-.4.9a13.4 13.4 0 01-6 6 25.5 25.5 0 01-7 1.2l-7.4.2h-70.7a16.7 16.7 0 01-3-.2c-.2 0-.3-.1-.3-.2 0-1 21.3-3.5 47.7-5.5a743.5 743.5 0 0147.2-2.4z"
      />
      <path
        fill="#26b0d5"
        d="M-244.2-5880.2v.1c-1.7 1-22.4 3.4-47.7 5.5a963.5 963.5 0 01-42.1 2.4h-1.5a23.5 23.5 0 01-4.2-.2c-.2 0-.3-.1-.3-.2 0-1 21.4-3.5 47.8-5.6 20.3-1.6 37.8-2.5 44.8-2.4 2 0 3.2.2 3.3.4z"
      />
      <path
        fill="none"
        stroke="rgba(255,255,255,0.44)"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth=".5"
        d="M-368-5870.8c-1-.1-1.8-6.8-1.8-15.2s.8-15 1.7-15.1"
      />
      <path
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth=".5"
        d="M-366.6-5878c-.3 4.3-.9 7.1-1.5 7.2"
      />
      <path
        fill="#eceade"
        d="M-364.7-5893.2l-7 10.3a1 1 0 000 1.3l7 10.3a1 1 0 00.9.5h72a1 1 0 001-1.1v-20.7a1 1 0 00-1-1h-72a1 1 0 00-.9.4zm-.8 10.5a1.6 1.6 0 01-1.6 1.6 1.6 1.6 0 01-1.6-1.6 1.6 1.6 0 011.6-1.6 1.6 1.6 0 011.6 1.6z"
      />
      <path
        fill="#f7f7f2"
        d="M-364.6-5893.3v.1h-.1l-6.8 10a1 1 0 000 1.1l7 10.1a1 1 0 00.8.5h71.6a1 1 0 001-1l.3-20v-.2a1 1 0 00-1-1h-71.9a1 1 0 00-.9.4zm-4.1 10.6a1.6 1.6 0 011.6-1.6 1.6 1.6 0 011.6 1.6 1.6 1.6 0 01-1.6 1.6 1.6 1.6 0 01-1.6-1.6z"
      />
      <path
        fill="#fff"
        d="M-364.6-5893.3v.1h-.1l-6.8 10a1 1 0 000 1.1l7 10.1a1 1 0 00.8.5h71.6a1 1 0 001-1l.3-20v-.2a1 1 0 00-1-1h-71.9a1 1 0 00-.9.4zm-4.1 10.6a1.6 1.6 0 011.6-1.6 1.6 1.6 0 011.6 1.6 1.6 1.6 0 01-1.6 1.6 1.6 1.6 0 01-1.6-1.6z"
        opacity=".3"
      />
      <path
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth=".5"
        d="M-368-5901.1c.8.1 1.6 6.8 1.6 15.1v4.7"
      />
      <path
        fill="#26b0d5"
        d="M-311-5881.7c1.6-2 .6-4.7 2-6.8.4.4.7.6.8.9l1.5 10.9-.6.5c-1.3-1.7-.8-3.8-1.5-5.7l-.8 1c-1.2 1.4-2.1 1.3-3-.4l-1.1-2.3c-1.2 2.1-.3 4.6-1.4 7-.4-.7-.7-1-.7-1.3a234 234 0 01-.3-6.6 9 9 0 01.2-1.6 1.6 1.6 0 011.7-1.3c.4 0 1 .7 1.3 1.2.5 1.1.8 2.4 1.2 3.6a4.6 4.6 0 00.6 1zm-28.4 2.8l1.4-4.6c.4-1.4 0-3.2 1.5-4.6a4.7 4.7 0 01.3 1.5l-1.8 7.5a3.3 3.3 0 01-.6 1.2c-.9 1.1-1.9 1-2.6-.3l-.7-2a26.9 26.9 0 01-1.4 2.5c-.7 1-1.5.9-2-.2a2.8 2.8 0 01-.3-.6 38.6 38.6 0 01-1.4-8.5c1.3 0 1.2.8 1.3 1.3l1 5.3a9.7 9.7 0 00.4 1.3c1.5-1.8.8-4.3 2.4-6 1.5 2 .7 4.4 2.5 6.2zm13.8 1.9c-1.5-3.3-.2-6.4-.5-9.5a22.4 22.4 0 012-1.1 3.1 3.1 0 013.6 1c.7 1 .4 2.1-1 3.2l-1.5 1a6.2 6.2 0 002.8 2.9 23 23 0 003.5 1.1c-1 1.2-2.2 1.4-4.1.2a38.2 38.2 0 01-3.7-3c-.8 1.2.4 2.8-1 4.1zm4-8.5a1.4 1.4 0 00-1.8-.8 1.4 1.4 0 00-.2.1 2.6 2.6 0 00-1 2.8 4.5 4.5 0 003-2.1zm-8.1 8.2c-2-.6-.7-2.2-1.5-3.4l-1.9-.2c-1.2.8-.3 2.6-2.1 3.3a6.2 6.2 0 01-.1-1.7l1.8-7.1a1.5 1.5 0 011.5-1.2c.8 0 1.1.5 1.4 1.1a16 16 0 01.9 9.2zm-1-5l-.9-2.9h-.5l-1 3z"
      />
    </g>
    <path
      fill="none"
      stroke="#d3eff6"
      strokeMiterlimit="10"
      strokeWidth="7.9"
      d="M549 139.5c0-92.2 35.9-33 134-45s197.6-51.7 223-4.7"
    />
    <path
      fill="none"
      stroke="#80ba90"
      strokeDasharray="24.6 49.2 9.8"
      strokeLinecap="round"
      strokeMiterlimit="10"
      strokeWidth="3.9"
      d="M549 139.5c0-92.2 35.9-33 134-45S880.1 42 905.4 89.2"
      className="l-homepage-hero-lab-asset__stroke"
    />
    <path
      fill="none"
      stroke="#f496d0"
      strokeDasharray="24.6 49.2 9.8"
      strokeLinecap="round"
      strokeMiterlimit="10"
      strokeWidth="3.9"
      d="M218 138.8c0-14.1-.3-27-.2-29.9 5.8-230.5-330.2-33.8-114.3 163.3 83.1 75.8 199.3 96.5 275.7 96.5 411.4 0 380.6-178 490.7-191.5"
      className="l-homepage-hero-lab-asset__stroke"
    />
    <path
      fill="#d3eff6"
      d="M240.5 160c-.2.6-2 1.1-5 1.5l-5 .6a171.2 171.2 0 01-30.7-.6c-3-.4-4.8-1-5-1.5v-.2 196.6a20.5 20.5 0 001 6.2 21.9 21.9 0 0011 12.7l1.6.8a23.7 23.7 0 009.2 1.8 23.9 23.9 0 009.3-1.8l1.7-.8a21.8 21.8 0 0011-12.7 20.1 20.1 0 001-6.2V160z"
    />
    <path
      fill="#c8ebf3"
      d="M239 162.4v194a18.7 18.7 0 01-1 5.7v.3a20.4 20.4 0 01-10.2 11.6l-1.6.7a22.4 22.4 0 01-8.6 1.7 22.2 22.2 0 01-8.7-1.7l-1.5-.7a20.5 20.5 0 01-10.3-11.8v-.3a19 19 0 01-.9-5.5v-194a29.2 29.2 0 003.3.6l5 .5a172 172 0 0031.2-.5 29.4 29.4 0 003.3-.6m-44.3-2.6v196.6a20.5 20.5 0 001 6.2 21.9 21.9 0 0011 12.7l1.7.8a23.7 23.7 0 009.2 1.8 23.9 23.9 0 009.2-1.8 20 20 0 001.7-.8 21.8 21.8 0 0011-12.7 20.2 20.2 0 001-6.2V160a.1.1 0 010 .1c-.3.6-2 1.1-5 1.5l-5 .6a171.1 171.1 0 01-30.8-.6c-3-.4-4.8-1-5-1.5v-.2z"
    />
    <path
      fill="none"
      stroke="rgba(246,246,241,0.58)"
      strokeLinecap="round"
      strokeMiterlimit="10"
      strokeWidth="7.4"
      d="M191.6 172.4c.2-1.6 11.8-2.9 26-2.9s25.7 1.3 26 2.9"
    />
    <path
      fill="#d3eff6"
      d="M351 160c-.3.6-2 1.1-5 1.5l-5 .6a171.2 171.2 0 01-30.8-.6c-3-.4-4.8-1-5-1.5v-.2 196.6a20.5 20.5 0 001 6.2 21.9 21.9 0 0011 12.7l1.7.8a23.7 23.7 0 009.2 1.8 23.9 23.9 0 009.2-1.8l1.7-.8a21.8 21.8 0 0011-12.7 20.1 20.1 0 001-6.2V160z"
    />
    <path
      fill="#c8ebf3"
      d="M349.4 162.4v194a18.7 18.7 0 01-.9 5.7v.3a20.4 20.4 0 01-10.3 11.6l-1.5.7a22.4 22.4 0 01-8.7 1.7 22.2 22.2 0 01-8.6-1.7l-1.6-.7a20.5 20.5 0 01-10.3-11.8v-.3a19 19 0 01-.8-5.5v-194a29.1 29.1 0 003.2.6l5 .5a172 172 0 0031.2-.5 29.4 29.4 0 003.3-.6m-44.2-2.6v196.6a20.5 20.5 0 001 6.2 21.9 21.9 0 0011 12.7l1.6.8a23.7 23.7 0 009.2 1.8 23.9 23.9 0 009.3-1.8 20 20 0 001.6-.8 21.8 21.8 0 0011-12.7 20.1 20.1 0 001-6.2V160a.1.1 0 010 .1c-.2.6-2 1.1-5 1.5l-5 .6a171.1 171.1 0 01-30.8-.6c-3-.4-4.7-1-5-1.5v-.2z"
    />
    <path
      fill="none"
      stroke="rgba(246,246,241,0.58)"
      strokeLinecap="round"
      strokeMiterlimit="10"
      strokeWidth="7.4"
      d="M302 172.4c.3-1.6 11.8-2.9 26-2.9s25.8 1.3 26 2.9"
    />
    <path
      fill="#d3eff6"
      d="M461.4 160c-.2.6-2 1.1-5 1.5l-5 .6a171.2 171.2 0 01-30.8-.6c-3-.4-4.7-1-5-1.5v-.2 196.6a20.5 20.5 0 001 6.2 21.9 21.9 0 0011 12.7l1.7.8a23.7 23.7 0 009.2 1.8 23.9 23.9 0 009.2-1.8l1.7-.8a21.8 21.8 0 0011-12.7 20.2 20.2 0 001-6.2V160z"
    />
    <path
      fill="#c8ebf3"
      d="M459.8 162.4v194a18.7 18.7 0 01-.8 5.7l-.1.2v.1a20.5 20.5 0 01-10.2 11.6l-1.6.7a22.4 22.4 0 01-8.7 1.7 22.2 22.2 0 01-8.6-1.7l-1.6-.7a20.5 20.5 0 01-10.2-11.8l-.1-.3a19 19 0 01-.8-5.5v-194a29.2 29.2 0 003.3.6l5 .5a172 172 0 0031.2-.5 29.4 29.4 0 003.2-.6m-44.2-2.6v196.6a20.5 20.5 0 001 6.2 21.9 21.9 0 0011 12.7l1.6.8a23.7 23.7 0 009.2 1.8 23.9 23.9 0 009.3-1.8l1.7-.8a21.8 21.8 0 0011-12.7 20.2 20.2 0 001-6.2V160a.1.1 0 01-.1.1c-.2.6-2 1.1-5 1.5l-5 .6a171.1 171.1 0 01-30.7-.6c-3-.4-4.8-1-5-1.5v-.2z"
    />
    <path
      fill="none"
      stroke="rgba(246,246,241,0.58)"
      strokeLinecap="round"
      strokeMiterlimit="10"
      strokeWidth="7.4"
      d="M412.5 172.4c.2-1.6 11.8-2.9 26-2.9s25.7 1.3 26 2.9"
    />
    <g>
      <path
        fill="#d3eff6"
        d="M571.8 160c-.2.6-2 1.1-5 1.5l-5 .6a171.2 171.2 0 01-30.7-.6c-3-.4-4.8-1-5-1.5v-.2 196.6a20.5 20.5 0 001 6.2 21.9 21.9 0 0011 12.7l1.6.8a23.7 23.7 0 009.2 1.8 23.9 23.9 0 009.3-1.8l1.7-.8a21.8 21.8 0 0011-12.7 20.2 20.2 0 001-6.2V160z"
      />
      <path
        fill="#c8ebf3"
        d="M570.3 162.4v194a18.7 18.7 0 01-1 5.7v.3A20.4 20.4 0 01559 374l-1.6.7a22.3 22.3 0 01-8.6 1.7 22.2 22.2 0 01-8.7-1.7l-1.5-.7a20.5 20.5 0 01-10.3-11.8v-.3a19 19 0 01-.9-5.5v-194a29.2 29.2 0 003.3.6l5 .5a172 172 0 0031.2-.5 29.4 29.4 0 003.3-.6m-44.3-2.6v196.6a20.5 20.5 0 001 6.2 21.9 21.9 0 0011 12.7l1.7.8a23.7 23.7 0 009.2 1.8 23.9 23.9 0 009.2-1.8l1.7-.8a21.8 21.8 0 0011-12.7 20.2 20.2 0 001-6.2V160a.1.1 0 010 .1c-.3.6-2 1.1-5 1.5l-5 .6a171.1 171.1 0 01-30.8-.6c-3-.4-4.8-1-5-1.5v-.2z"
      />
      <path
        fill="none"
        stroke="rgba(246,246,241,0.58)"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="7.4"
        d="M522.9 172.4c.2-1.6 11.8-2.9 26-2.9s25.7 1.3 26 2.9"
      />
    </g>
    <g transform="translate(1144.7 6232.21)">
      <path
        fill="#eceade"
        d="M-1081.6-5769c.7.2 1.3 2.3 1.8 5.6l.6 5.7a193.8 193.8 0 01-.6 35c-.5 3.3-1 5.4-1.7 5.6h-.2 223.3a23.3 23.3 0 007-1 24.8 24.8 0 0014.5-12.5l.9-2a27 27 0 002-10.4 27.1 27.1 0 00-2-10.5l-1-2a24.8 24.8 0 00-14.3-12.4 23 23 0 00-7-1.1h-223.4z"
      />
      <path
        fill="url(#a)"
        d="M-1081.6-5769c.7.2 1.3 2.3 1.8 5.6l.6 5.7a193.8 193.8 0 01-.6 35c-.5 3.3-1 5.4-1.7 5.6h-.2 223.3a23.3 23.3 0 007-1 24.8 24.8 0 0014.5-12.5l.9-2a27 27 0 002-10.4 27.1 27.1 0 00-2-10.5l-1-2a24.8 24.8 0 00-14.3-12.4 23 23 0 00-7-1.1h-223.4z"
        opacity=".6"
      />
      <ellipse
        cx="2.9"
        cy="26.2"
        fill="#d8d6ce"
        rx="2.9"
        ry="26.2"
        transform="translate(-1084.55 -5769.1)"
      />
      <path
        fill="none"
        stroke="rgba(255,255,255,0.44)"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth=".9"
        d="M-1054.5-5716.4c-1.6-.3-3-12-3-26.6s1.4-26.4 3-26.6"
      />
      <path
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth=".9"
        d="M-1052-5729.2c-.5 7.5-1.4 12.6-2.5 12.8"
      />
      <path
        fill="#f7f7f2"
        d="M-1117.6-5761.9l-.3 5.4a182.2 182.2 0 01-5.7 32.7c-.9 2.8-1.7 4.6-2.3 5l14.1 2c.3 0 .6-.3 1-.8.9-1.4 2-4.6 3.2-9.5v-.1a224.4 224.4 0 004.2-26.4v-.2c.4-5 .4-8.4 0-10-.3-.6-.5-1-.7-1l-14.1-2.5c.5.6.7 2.5.6 5.4z"
      />
      <ellipse
        cx="24.5"
        cy="2.7"
        fill="#f7f7f2"
        rx="24.5"
        ry="2.7"
        transform="rotate(-80.96 -3914.65 -2198.5)"
      />
      <ellipse
        cx="26.2"
        cy="2.9"
        fill="#d8d6ce"
        rx="26.2"
        ry="2.9"
        transform="rotate(-80.96 -3912.66 -2199.21)"
      />
      <path fill="#d8d6ce" d="M-1115.1-5769.1l-8.2 51.6-18.1.6 9.2-58.3z" />
      <ellipse
        cx="29.5"
        cy="3.3"
        fill="#f7f7f2"
        rx="29.5"
        ry="3.3"
        transform="rotate(-80.96 -3921.62 -2188.15)"
      />
      <path
        fill="url(#d)"
        d="M-845-5723.5a.2.2 0 01-.1 0 20.6 20.6 0 01-13.1 4.8h-42.1c-1.7 0-2.7 0-2.7-.2 0-.6 12.9-2.1 28.9-3.4 16-1.3 29-1.8 29-1.2z"
      />
      <path
        fill="#f496d0"
        d="M-845-5723.5a.2.2 0 01-.1 0c-1 .7-13.5 2.1-28.9 3.4-11.6.9-21.7 1.4-26.3 1.4-1.7 0-2.7 0-2.7-.2 0-.6 12.9-2.1 28.9-3.4 16-1.3 29-1.8 29-1.2z"
      />
      <g opacity=".5">
        <path
          fill="#d8d6ce"
          d="M-836-5753.4l-1-2a24.7 24.7 0 00-14.3-12.4 22.9 22.9 0 00-7-1.1h-223.4.1c.7.2 1.3 2.3 1.8 5.6l.6 5.7a196.1 196.1 0 01-.6 35c-.5 3.3-1 5.4-1.7 5.6h-.2 223.3a23.2 23.2 0 007-1 24.8 24.8 0 0014.5-12.6l.9-1.9a27 27 0 002-10.4 27 27 0 00-2-10.5zm-1.6 20.3l-.8 1.8a23.3 23.3 0 01-13.4 11.6l-.3.1a21.6 21.6 0 01-6.3 1h-220.4a34.5 34.5 0 00.7-3.8l.6-5.7a192.5 192.5 0 00-.6-35.4 34.6 34.6 0 00-.7-3.7h220.4a21.3 21.3 0 016.4 1h.4a23.2 23.2 0 0113.2 11.6 18.4 18.4 0 01.8 1.8 25.4 25.4 0 012 9.9 25.3 25.3 0 01-2 9.8z"
        />
        <path
          fill="#f496d0"
          d="M-907-5718.7h-8a3.4 3.4 0 011-1 4.6 4.6 0 014.1-.3 27.1 27.1 0 012.8 1.3z"
        />
      </g>
      <path
        fill="#eceade"
        d="M-1048.5-5755.7l-12.4 18a2 2 0 000 2.2l12.3 18a2 2 0 001.6 1h126a2 2 0 001.9-2v-36.1a2 2 0 00-2-1.9h-126a1.9 1.9 0 00-1.4.8zm-1.5 18.4a2.8 2.8 0 01-2.8 2.8 2.8 2.8 0 01-2.8-2.8 2.8 2.8 0 012.8-2.8 2.8 2.8 0 012.8 2.8z"
      />
      <path
        fill="#f7f7f2"
        d="M-1048.4-5756l-.1.3-12 17.4a1.9 1.9 0 000 2l12.1 17.7a1.9 1.9 0 001.6.8h125.4a1.9 1.9 0 001.9-1.8l.4-35v-.3a1.9 1.9 0 00-1.9-1.9h-125.8a1.9 1.9 0 00-1.6.8zm-7.2 18.7a2.8 2.8 0 012.8-2.8 2.8 2.8 0 012.8 2.8 2.8 2.8 0 01-2.8 2.8 2.8 2.8 0 01-2.8-2.8z"
      />
      <path
        fill="#fff"
        d="M-1048.4-5756l-.1.3-12 17.4a1.9 1.9 0 000 2l12.1 17.7a1.9 1.9 0 001.6.8h125.4a1.9 1.9 0 001.9-1.8l.4-35v-.3a1.9 1.9 0 00-1.9-1.9h-125.8a1.9 1.9 0 00-1.6.8zm-7.2 18.7a2.8 2.8 0 012.8-2.8 2.8 2.8 0 012.8 2.8 2.8 2.8 0 01-2.8 2.8 2.8 2.8 0 01-2.8-2.8z"
        opacity=".3"
      />
      <path
        fill="#f496d0"
        d="M-966.3-5725.4c-3.5-1.9-2.7-5.1-3-7.8-.5-2.7-.4-5.4-.6-8.9-6.2 4.2-3.6 10.2-5 15.9-1-1.3-2-2-2-2.5l-.1-16a.7.7 0 01.7-.7.7.7 0 01.5.2 6.6 6.6 0 001.7 1.6 16.4 16.4 0 012.6-1.3c2.3-.6 3.5 0 4.3 2.3a7.6 7.6 0 01.4 2l1 13.1a8.7 8.7 0 01-.5 2.1zm-24.2-20.8c1.6 1 1.6 4.3 5.2.6.4-.2 1.9.6 2.2 1.3a31.6 31.6 0 012.5 17.4c0 .2-.4.4-1.2.9-2.6-4.8-.7-10.6-3.7-15.4-2.8 2.4-2.6 5.9-3.2 9-.3 1.3.6 3.3-1.7 3.8-1.5-2.5-1.6-11.5-.1-17.6zm-11.7-.4c.4 6.2-.7 11.8 2.6 17.3 3-5 2.2-10.4 3.4-15.5a1.3 1.3 0 011.6-1 1.4 1.4 0 01.7.3.5.5 0 01.1.4 125 125 0 01-2.4 15.8c-.9 3.6-4 3.7-6.3.7a5.6 5.6 0 01-1.2-2.6c-.4-4.8-.7-9.7-.9-14.6 0-.4.4-.8.9-1.3a.9.9 0 011.2 0 .9.9 0 01.3.5zm44.2 7.5c1-2.3 1.5-4.5 2.9-7.2a1 1 0 011.3-.4 1 1 0 01.4.4 2.7 2.7 0 01.5 1.5c-.6 5-1.4 10-2.4 15-.8 4-1.8 4.4-6.4 3.7-.8-3 3-1.8 3.3-3.6l1.2-6c-2.3-.2-4.9.3-5.5-2.5-.5-2.6-1.2-5.3 1-8.4a.4.4 0 01.6-.1.4.4 0 01.2.3c.3 2.8 0 4.9.3 7 .7.1 1.9.1 2.6.3zm-62.6 6.1a1.3 1.3 0 011.2-1.3 1.3 1.3 0 011 .3 34.9 34.9 0 005 3.4 4 4 0 003.7-.3 4.2 4.2 0 00-.2-3.8c-1.5-2.4-3.4-4.5-5.1-6.8a4 4 0 01.3-5.5 4.2 4.2 0 014.7-1.5 1 1 0 01.6 1.3 1 1 0 01-.4.5l-2.5 1.5a1.4 1.4 0 00-.5 2 1.4 1.4 0 00.1.1l4.1 5.2a8.4 8.4 0 012.3 7 4.4 4.4 0 01-3.6 3.8c-3.5.8-9.3-2.2-10.6-5.6a1 1 0 010-.2z"
      />
      <path
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth=".9"
        d="M-1054.5-5769.6c1.7.2 3 12 3 26.6 0 2.8 0 5.6-.2 8.1"
      />
    </g>
  </svg>
);

LabBg.propTypes = {
  className: PropTypes.string,
};

LabBg.defaultProps = {
  className: '',
};
